/* eslint-disable */
import { z } from 'zod'
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  ExpectedError: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AdditionalProductType = {
  __typename?: 'AdditionalProductType';
  minutes: Scalars['Int']['output'];
  priceAmount: Scalars['Float']['output'];
  priceId: Scalars['ID']['output'];
};

export type AdditionalProductsType = {
  __typename?: 'AdditionalProductsType';
  error?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<AdditionalProductType>>;
  success: Scalars['Boolean']['output'];
};

export type AgentAndErrorType = AgentCreateType | ErrorType;

export type AgentCreateResponseType = {
  __typename?: 'AgentCreateResponseType';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AgentCreateType = {
  __typename?: 'AgentCreateType';
  agent: AgentType;
  message: Scalars['String']['output'];
};

export type AgentIsReadyType = {
  __typename?: 'AgentIsReadyType';
  isReady: Scalars['Boolean']['output'];
  trainingGuide: Scalars['String']['output'];
};

export type AgentType = {
  __typename?: 'AgentType';
  businessAddress?: Maybe<BusinessAddressType>;
  callService: Scalars['String']['output'];
  callTransfer: Array<CallTransferType>;
  callTransferActive: Scalars['Boolean']['output'];
  emailNotification?: Maybe<EmailNotificationType>;
  fillerAudio?: Maybe<FillerAudioType>;
  googleCalendar: Scalars['Boolean']['output'];
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialMessage: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  priceId: Scalars['String']['output'];
  terminateCallAction?: Maybe<TerminateCallActionType>;
  textNotification?: Maybe<TextNotificationType>;
  timeZone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trainingGuide?: Maybe<Scalars['String']['output']>;
  userSubscriptionCancelDate?: Maybe<Scalars['String']['output']>;
  userSubscriptionPremium?: Maybe<Scalars['Boolean']['output']>;
  voiceId?: Maybe<Scalars['Int']['output']>;
};

export type AgentVoiceType = {
  __typename?: 'AgentVoiceType';
  available: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  premium: Scalars['Boolean']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
};

export type AgentVoicesType = {
  __typename?: 'AgentVoicesType';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  voices?: Maybe<Array<AgentVoiceType>>;
};

export type AgentsType = {
  __typename?: 'AgentsType';
  agents: Array<AgentType>;
  callService: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AnswerType = {
  __typename?: 'AnswerType';
  answerValue: Scalars['String']['output'];
  page: Scalars['Int']['output'];
};

export type AnswersResponse = AnswersType | ErrorType;

export type AnswersType = {
  __typename?: 'AnswersType';
  answers: Array<AnswerType>;
  isAgentVoiceChosen: Scalars['Boolean']['output'];
  lastPage: Scalars['String']['output'];
  onFinishStepper: Scalars['Boolean']['output'];
};

export type AuthTokenType = OutputInterface & {
  __typename?: 'AuthTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<UserModelType>;
};

export type BaseKnowledgeDataType = {
  __typename?: 'BaseKnowledgeDataType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  processingStatus: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type BlockedNumberErrorType = {
  __typename?: 'BlockedNumberErrorType';
  message: Scalars['String']['output'];
};

export type BlockedNumberInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BlockedNumberResponseType = BlockedNumberErrorType | BlockedNumberSuccessType;

export type BlockedNumberSuccessType = {
  __typename?: 'BlockedNumberSuccessType';
  blockedNumbers?: Maybe<Array<BlockedNumberType>>;
  message: Scalars['String']['output'];
};

export type BlockedNumberType = {
  __typename?: 'BlockedNumberType';
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type BusinessAddressType = {
  __typename?: 'BusinessAddressType';
  bundleStatus?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
};

export type CallActivityType = {
  __typename?: 'CallActivityType';
  recordingUri: Scalars['String']['output'];
};

export type CallInstanceListType = {
  __typename?: 'CallInstanceListType';
  calls: Array<CallInstanceType>;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
};

export type CallInstanceType = {
  __typename?: 'CallInstanceType';
  callDuration: Scalars['String']['output'];
  callSid?: Maybe<Scalars['String']['output']>;
  called: Scalars['String']['output'];
  caller: Scalars['String']['output'];
  recordingUri?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
};

export type CallTransferInput = {
  beforTransferingMsg?: InputMaybe<Scalars['String']['input']>;
  callerIdStatus?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instructionBeforTransfer?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CallTransferMutations = {
  __typename?: 'CallTransferMutations';
  /** Mutation for delete call transfer record */
  delete: Response;
  /** Mutation for update or create agent's call transfer records */
  updateOrCreate: CallTransferResponseType;
};


export type CallTransferMutationsDeleteArgs = {
  callTransferId: Scalars['ID']['input'];
};


export type CallTransferMutationsUpdateOrCreateArgs = {
  agentId: Scalars['ID']['input'];
  callTransferActive: Scalars['Boolean']['input'];
  callTransfers?: InputMaybe<Array<CallTransferInput>>;
};

export type CallTransferResponseType = CallTransferSuccessType | ErrorType;

export type CallTransferSuccessType = {
  __typename?: 'CallTransferSuccessType';
  callTransfers: Array<CallTransferType>;
  message: Scalars['String']['output'];
};

export type CallTransferType = {
  __typename?: 'CallTransferType';
  beforTransferingMsg: Scalars['String']['output'];
  callerIdStatus: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instructionBeforTransfer?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type ChangeProfileResponse = {
  __typename?: 'ChangeProfileResponse';
  company: CompanyType;
  message: Scalars['String']['output'];
};

export type CheckoutSessionType = {
  __typename?: 'CheckoutSessionType';
  checkoutSessionUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChoiceType = {
  __typename?: 'ChoiceType';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type CompanyType = {
  __typename?: 'CompanyType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DjangoModelType = {
  __typename?: 'DjangoModelType';
  pk: Scalars['ID']['output'];
};

export type EmailNotificationType = {
  __typename?: 'EmailNotificationType';
  active: Scalars['Boolean']['output'];
  email1?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  email3?: Maybe<Scalars['String']['output']>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  message: Scalars['String']['output'];
};

export type ErrorTypeSuccessType = ErrorType | SuccessType;

export type FillerAudioType = {
  __typename?: 'FillerAudioType';
  active: Scalars['Boolean']['output'];
};

export type InstagramImagesResponse = ErrorType | UserModelType;

export type KnowledgeDataType = {
  __typename?: 'KnowledgeDataType';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  knowledgeData?: Maybe<Array<BaseKnowledgeDataType>>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addSubscriptionToExisting: CheckoutSessionType;
  answerRegistrationQuestion: Response;
  /**
   * Archive account and revoke refresh tokens.
   *
   *     User must be verified and confirm password.
   *
   */
  archiveAccount: MutationNormalOutput;
  /** Block a caller's number and move all calls from that number to the trash. */
  blockNumber: Response;
  buyTelephoneNumber: Response;
  callTransfer: CallTransferMutations;
  cancelSubscriptionItem: CheckoutSessionType;
  changeAgentTitle: Response;
  changeAgentVoice: Response;
  changeAllowToStepper: Response;
  changeCallService: Response;
  changeCallServiceByAgentId: Response;
  changeFinishedStepper: Response;
  changeInitialMessage: Response;
  changeKnowledgeDataStatus: Response;
  changeKnowledgeDataText: UploadedKnowledgeDataResponseType;
  changePassword: Response;
  changePhoneNumberWhileRegistration: Response;
  changeProfile: ChangeProfileResponse;
  changeProfilePassword: Response;
  changeStatusIsDelete: Response;
  changeTimeZone: Response;
  changeTrainingGuide: Response;
  createAgent: AgentCreateResponseType;
  createAgentBasedOnOtherAgent: AgentAndErrorType;
  createCheckoutSession: CheckoutSessionType;
  createHollowAgent: AgentAndErrorType;
  createPortalSession: PortalSessionType;
  createSubscription: SubscriptionSessionType;
  /** Creates a Twilio bundle and performs all necessary steps to configure it. */
  createTwilioBundle: Response;
  /**
   * Delete account permanently or make `user.is_active=False`.
   *
   *     The behavior is defined on settings. Anyway user refresh tokens are
   *     revoked.
   *
   *     User must be verified and confirm password.
   *
   */
  deleteAccount: MutationNormalOutput;
  /** Delete a blocked number and optionally restore related calls. */
  deleteBlockedNumber: Response;
  deleteKnowledgeData: Response;
  emailNotification: Response;
  fillerAudio: Response;
  googleCalendar: Response;
  /**
   * Change user password without old password.
   *
   *     Receive the token that was sent by email.
   *
   *     If token and new passwords are valid, update user password and in
   *     case of using refresh tokens, revoke all of them.
   *
   *     Also, if user has not been verified yet, verify it.
   *
   */
  passwordReset: MutationNormalOutput;
  /**
   *
   *     Set user password - for password-less registration
   *
   *     Receive the token that was sent by email.
   *
   *     If token and new passwords are valid, set
   *     user password and in case of using refresh
   *     tokens, revoke all of them.
   *
   *     Also, if user has not been verified yet, verify it.
   *
   */
  passwordSet: MutationNormalOutput;
  preventAutomaticCancellation: CheckoutSessionType;
  recreateSubscription: CheckoutSessionType;
  /**
   * ### refreshToken to generate a new login token:
   *
   *     *Use this only if `JWT_LONG_RUNNING_REFRESH_TOKEN` is True*
   *
   *     using the refresh-token you already got during authorization, and
   *     obtain a brand-new token (and possibly a new refresh token if you revoked the previous).
   *     This is an alternative to log in when your token expired.
   *
   */
  refreshToken: ObtainJsonWebTokenType;
  register: ErrorTypeSuccessType;
  /**
   * Sends activation email.
   *
   *     It is called resend because theoretically the first activation email
   *     was sent when the user registered.
   *
   *     If there is no user with the requested email, a successful response
   *     is returned.
   *
   */
  resendActivationEmail: MutationNormalOutput;
  resendVerificationCode: Response;
  retryUpload: Response;
  /**
   * ### Suspends a refresh token.
   *
   *     *token must exist to be revoked.*
   *
   */
  revokeToken: RevokeRefreshTokenType;
  sendForgotPassword: Response;
  /**
   * Send password reset email.
   *
   *     For non verified users, send an activation email instead.
   *
   *     If there is no user with the requested email, a successful response
   *     is returned.
   *
   */
  sendPasswordResetEmail: MutationNormalOutput;
  socialAuth: Response;
  terminateCallAction: Response;
  textNotification: Response;
  tokenAuth: AuthTokenType;
  /** Unblock a caller's number and restore related calls from trash. */
  unblockNumber: Response;
  /**
   * Update user model fields, defined on settings.
   *
   *     User must be verified.
   *
   */
  updateAccount: MutationNormalOutput;
  /** Update or create user's blocked numbers. */
  updateOrCreateBlockedNumber: BlockedNumberResponseType;
  uploadFile: UploadedKnowledgeDataResponseType;
  uploadText: UploadedKnowledgeDataResponseType;
  uploadUrl: UploadedKnowledgeDataResponseType;
  /**
   * Verify user account.
   *
   *     Receive the token that was sent by email. If the token is valid,
   *     make the user verified by making the `user.status.verified` field
   *     true.
   *
   */
  verifyAccount: MutationNormalOutput;
  verifyCode: VerifyCodeResponseType;
  /**
   * ### Checks if a token is not expired and correct.
   *
   *     *Note that this is not for refresh tokens.*
   *
   */
  verifyToken: VerifyTokenType;
};


export type MutationAddSubscriptionToExistingArgs = {
  email: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationAnswerRegistrationQuestionArgs = {
  question: QuestionAnswerType;
};


export type MutationArchiveAccountArgs = {
  password: Scalars['String']['input'];
};


export type MutationBlockNumberArgs = {
  callSid: Scalars['String']['input'];
};


export type MutationBuyTelephoneNumberArgs = {
  agentId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationCancelSubscriptionItemArgs = {
  email: Scalars['String']['input'];
  subscriptionItemId: Scalars['String']['input'];
};


export type MutationChangeAgentTitleArgs = {
  agentId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationChangeAgentVoiceArgs = {
  agentId: Scalars['ID']['input'];
  voiceId: Scalars['Int']['input'];
};


export type MutationChangeAllowToStepperArgs = {
  allowToStepper: Scalars['Boolean']['input'];
  variantCreateAgent: Scalars['Int']['input'];
};


export type MutationChangeCallServiceArgs = {
  serviceType: Scalars['String']['input'];
};


export type MutationChangeCallServiceByAgentIdArgs = {
  agentId: Scalars['ID']['input'];
  serviceType: Scalars['String']['input'];
};


export type MutationChangeFinishedStepperArgs = {
  finishedStepper: Scalars['Boolean']['input'];
};


export type MutationChangeInitialMessageArgs = {
  agentId: Scalars['ID']['input'];
  initialMessage: Scalars['String']['input'];
};


export type MutationChangeKnowledgeDataStatusArgs = {
  knowledgeDataId: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationChangeKnowledgeDataTextArgs = {
  knowledgeDataId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
};


export type MutationChangePhoneNumberWhileRegistrationArgs = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationChangeProfileArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  language?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeProfilePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
};


export type MutationChangeStatusIsDeleteArgs = {
  callSidList: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationChangeTimeZoneArgs = {
  agentId: Scalars['ID']['input'];
  timeZone: Scalars['String']['input'];
};


export type MutationChangeTrainingGuideArgs = {
  agentId: Scalars['ID']['input'];
  newGuide: Scalars['String']['input'];
};


export type MutationCreateAgentArgs = {
  address: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationCreateAgentBasedOnOtherAgentArgs = {
  address: Scalars['String']['input'];
  basedOnAgentId: Scalars['ID']['input'];
  businessName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationCreateCheckoutSessionArgs = {
  email: Scalars['String']['input'];
  isTrial: Scalars['Boolean']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationCreateHollowAgentArgs = {
  address: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationCreatePortalSessionArgs = {
  manageType?: Scalars['String']['input'];
};


export type MutationCreateSubscriptionArgs = {
  email: Scalars['String']['input'];
  isTrial?: Scalars['Boolean']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
};


export type MutationCreateTwilioBundleArgs = {
  businessName: Scalars['String']['input'];
  businessRegistrationNumber: Scalars['String']['input'];
  businessWebsite: Scalars['String']['input'];
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  street: Scalars['String']['input'];
};


export type MutationDeleteAccountArgs = {
  password: Scalars['String']['input'];
};


export type MutationDeleteBlockedNumberArgs = {
  blockedNumberId: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeDataArgs = {
  knowledgeDataId: Scalars['ID']['input'];
};


export type MutationEmailNotificationArgs = {
  active: Scalars['Boolean']['input'];
  agentId: Scalars['ID']['input'];
  email1: Scalars['String']['input'];
  email2: Scalars['String']['input'];
  email3: Scalars['String']['input'];
};


export type MutationFillerAudioArgs = {
  active: Scalars['Boolean']['input'];
  agentId: Scalars['ID']['input'];
};


export type MutationGoogleCalendarArgs = {
  active: Scalars['Boolean']['input'];
  agentId: Scalars['ID']['input'];
};


export type MutationPasswordResetArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationPasswordSetArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationPreventAutomaticCancellationArgs = {
  email: Scalars['String']['input'];
};


export type MutationRecreateSubscriptionArgs = {
  email: Scalars['String']['input'];
  isTrial?: Scalars['Boolean']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
  revokeRefreshToken: Scalars['Boolean']['input'];
};


export type MutationRegisterArgs = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  recaptchaCode: Scalars['String']['input'];
};


export type MutationResendActivationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendVerificationCodeArgs = {
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['Int']['input'];
};


export type MutationRetryUploadArgs = {
  knowledgeDataId: Scalars['ID']['input'];
};


export type MutationRevokeTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationSendForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSocialAuthArgs = {
  accessToken: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};


export type MutationTerminateCallActionArgs = {
  active: Scalars['Boolean']['input'];
  agentId: Scalars['ID']['input'];
};


export type MutationTextNotificationArgs = {
  active: Scalars['Boolean']['input'];
  agentId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationTokenAuthArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUnblockNumberArgs = {
  callSid: Scalars['String']['input'];
};


export type MutationUpdateAccountArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrCreateBlockedNumberArgs = {
  blockedNumbers?: InputMaybe<Array<BlockedNumberInput>>;
  userId: Scalars['ID']['input'];
};


export type MutationUploadFileArgs = {
  agentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadTextArgs = {
  agentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationUploadUrlArgs = {
  agentId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};


export type MutationVerifyAccountArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationNormalOutput = {
  __typename?: 'MutationNormalOutput';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 *
 *     encapsulates token data, and refresh token data if `JWT_LONG_RUNNING_REFRESH_TOKEN` is on.
 *     with an output interface.
 *
 */
export type ObtainJsonWebTokenType = OutputInterface & {
  __typename?: 'ObtainJSONWebTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<UserType>;
};

export type OutputInterface = {
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PhoneNumberType = {
  __typename?: 'PhoneNumberType';
  phoneNumber: Scalars['String']['output'];
};

export type PhoneNumbersType = {
  __typename?: 'PhoneNumbersType';
  error?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<PhoneNumberType>>;
  success: Scalars['Boolean']['output'];
};

export type PortalSessionType = {
  __typename?: 'PortalSessionType';
  error?: Maybe<Scalars['String']['output']>;
  portalSessionUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProductType = {
  __typename?: 'ProductType';
  description: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  priceAmount: Scalars['Float']['output'];
  priceId: Scalars['ID']['output'];
};

export type ProductsType = {
  __typename?: 'ProductsType';
  error?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<ProductType>>;
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  getActiveProducts: ProductsType;
  getActiveProductsWithoutTrial: ProductsType;
  getAdditionalProducts: AdditionalProductsType;
  getAgentHistory: CallInstanceListType;
  getAgentVoices: AgentVoicesType;
  getAllQuestions: QuestionsResponse;
  getAnswered: AnswersResponse;
  getCallActivityBySid: TranscriptionType;
  getCurrentSubscriptionInfo: SubscriptionInfoType;
  getCurrentUserMinutes: Scalars['Int']['output'];
  getKnowledgeData: KnowledgeDataType;
  getMe: InstagramImagesResponse;
  getPhoneNumbers: PhoneNumbersType;
  getRecordingUri: CallActivityType;
  getRegistrationAgentVoices: RegistrationAgentVoicesType;
  getTimeZones: TimeZone;
  getUserAgent: AgentAndErrorType;
  getUserAgentById: AgentAndErrorType;
  getUserAgentIsReady: AgentIsReadyType;
  getUserAgents: AgentsType;
  me: UserType;
  /** Returns the current user if he is not anonymous. */
  publicUser?: Maybe<UserType>;
};


export type QueryGetAgentHistoryArgs = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  blockedOnly?: Scalars['Boolean']['input'];
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  dateAsc?: Scalars['Boolean']['input'];
  durationAsc?: Scalars['Boolean']['input'];
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  filterDate?: Scalars['Boolean']['input'];
  filterDuration?: Scalars['Boolean']['input'];
  filterTime?: Scalars['Boolean']['input'];
  isDelete?: Scalars['Boolean']['input'];
  laterFirst?: Scalars['Boolean']['input'];
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  startDatetime?: InputMaybe<Scalars['String']['input']>;
  timeAsc?: Scalars['Boolean']['input'];
};


export type QueryGetCallActivityBySidArgs = {
  blockedOnly?: Scalars['Boolean']['input'];
  sid: Scalars['String']['input'];
};


export type QueryGetKnowledgeDataArgs = {
  agentId: Scalars['ID']['input'];
};


export type QueryGetPhoneNumbersArgs = {
  cityCode?: InputMaybe<Scalars['Int']['input']>;
  countryCode: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  numberType: Scalars['String']['input'];
};


export type QueryGetRecordingUriArgs = {
  callSid: Scalars['String']['input'];
};


export type QueryGetUserAgentByIdArgs = {
  agentId: Scalars['Int']['input'];
};

export type QuestionAnswerType = {
  answer: Scalars['String']['input'];
  questionId: Scalars['Int']['input'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  choices: Array<ChoiceType>;
  id: Scalars['ID']['output'];
  page: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
};

export type QuestionsResponse = ErrorType | QuestionsType;

export type QuestionsType = {
  __typename?: 'QuestionsType';
  questions: Array<QuestionType>;
};

/**
 *
 * Refresh token can be used to obtain a new token instead of log in again
 * when the token expires.
 *
 * *This is only used if `JWT_LONG_RUNNING_REFRESH_TOKEN` is set to True.*
 *
 */
export type RefreshTokenType = {
  __typename?: 'RefreshTokenType';
  created: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  isExpired: Scalars['Boolean']['output'];
  revoked?: Maybe<Scalars['DateTime']['output']>;
  /** randomly generated token that is attached to a FK user. */
  token: Scalars['String']['output'];
};

export type RegistrationAgentVoiceType = {
  __typename?: 'RegistrationAgentVoiceType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type RegistrationAgentVoicesType = {
  __typename?: 'RegistrationAgentVoicesType';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  voices?: Maybe<Array<RegistrationAgentVoiceType>>;
};

export type Response = ErrorType | SuccessType;

export type RevokeRefreshTokenType = {
  __typename?: 'RevokeRefreshTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  checkProcessingStatus: Array<Scalars['JSON']['output']>;
};


export type SubscriptionCheckProcessingStatusArgs = {
  agentId: Scalars['ID']['input'];
};

export type SubscriptionInfoType = {
  __typename?: 'SubscriptionInfoType';
  error?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<SubscriptionType>;
  success: Scalars['Boolean']['output'];
};

export type SubscriptionSessionType = {
  __typename?: 'SubscriptionSessionType';
  clientSecret?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  features: Array<Scalars['String']['output']>;
  nextBillingAmount: Scalars['Float']['output'];
  nextBillingDate: Scalars['DateTime']['output'];
  planName: Scalars['String']['output'];
  priceAmount: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
};

export type SuccessType = {
  __typename?: 'SuccessType';
  message: Scalars['String']['output'];
};

export type TerminateCallActionType = {
  __typename?: 'TerminateCallActionType';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
};

export type TextNotificationType = {
  __typename?: 'TextNotificationType';
  active: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type TimeZone = {
  __typename?: 'TimeZone';
  listTimeZones: Array<Scalars['String']['output']>;
};

/**
 *
 * the data that was used to create the token.
 *
 */
export type TokenPayloadType = {
  __typename?: 'TokenPayloadType';
  email: Scalars['String']['output'];
  /** when the token will be expired */
  exp: Scalars['DateTime']['output'];
  /** when the token was created */
  origIat: Scalars['DateTime']['output'];
};

/**
 *
 * encapsulates the token with the payload that was used to create the token.
 *
 */
export type TokenType = {
  __typename?: 'TokenType';
  payload: TokenPayloadType;
  /** The encoded payload, namely a token. */
  token: Scalars['String']['output'];
};

export type TranscriptionType = {
  __typename?: 'TranscriptionType';
  page: Scalars['Int']['output'];
  transcription?: Maybe<Scalars['String']['output']>;
};

export type UploadedKnowledgeDataResponseType = ErrorType | UploadedKnowledgeDataSuccessType;

export type UploadedKnowledgeDataSuccessType = {
  __typename?: 'UploadedKnowledgeDataSuccessType';
  knowledgeData: BaseKnowledgeDataType;
  message: Scalars['String']['output'];
};

export type UserModelType = {
  __typename?: 'UserModelType';
  company?: Maybe<CompanyType>;
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAgentCreated: Scalars['Boolean']['output'];
  isAgentDelete: Scalars['Boolean']['output'];
  isAllowToStepper: Scalars['JSON']['output'];
  isFinishedStepper: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  language: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type UserStatusType = {
  __typename?: 'UserStatusType';
  archived: Scalars['Boolean']['output'];
  verified: Scalars['Boolean']['output'];
};

export type UserType = {
  __typename?: 'UserType';
  archived: Scalars['Boolean']['output'];
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  logentrySet: Array<DjangoModelType>;
  status?: Maybe<UserStatusType>;
  verified: Scalars['Boolean']['output'];
};

export type VerifyCodeResponseType = ErrorType | VerifyCodeSuccessType;

export type VerifyCodeSuccessType = {
  __typename?: 'VerifyCodeSuccessType';
  message: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type VerifyTokenType = OutputInterface & {
  __typename?: 'VerifyTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<UserType>;
};

export type BuyTelephoneNumberMutationVariables = Exact<{
  agentId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type BuyTelephoneNumberMutation = { __typename?: 'Mutation', buyTelephoneNumber: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type ChangeAgentVoiceMutationVariables = Exact<{
  voiceId: Scalars['Int']['input'];
  agentId: Scalars['ID']['input'];
}>;


export type ChangeAgentVoiceMutation = { __typename?: 'Mutation', changeAgentVoice: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type ChangeCallServiceByAgentIdMutationVariables = Exact<{
  serviceType: Scalars['String']['input'];
  agentId: Scalars['ID']['input'];
}>;


export type ChangeCallServiceByAgentIdMutation = { __typename?: 'Mutation', changeCallServiceByAgentId: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type ChangeInitialMessageMutationVariables = Exact<{
  initialMessage: Scalars['String']['input'];
  agentId: Scalars['ID']['input'];
}>;


export type ChangeInitialMessageMutation = { __typename?: 'Mutation', changeInitialMessage: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type ChangeKnowledgeDataStatusMutationVariables = Exact<{
  knowledgeDataId: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
}>;


export type ChangeKnowledgeDataStatusMutation = { __typename?: 'Mutation', changeKnowledgeDataStatus: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type ChangeTrainingGuideMutationVariables = Exact<{
  newGuide: Scalars['String']['input'];
  agentId: Scalars['ID']['input'];
}>;


export type ChangeTrainingGuideMutation = { __typename?: 'Mutation', changeTrainingGuide: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type CreatePortalSessionMutationVariables = Exact<{
  manageType?: Scalars['String']['input'];
}>;


export type CreatePortalSessionMutation = { __typename?: 'Mutation', createPortalSession: { __typename?: 'PortalSessionType', success: boolean, error?: string | null, portalSessionUrl?: string | null } };

export type DeleteKnowledgeDataMutationVariables = Exact<{
  knowledgeDataId: Scalars['ID']['input'];
}>;


export type DeleteKnowledgeDataMutation = { __typename?: 'Mutation', deleteKnowledgeData: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type PreventAutomaticCancellationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type PreventAutomaticCancellationMutation = { __typename?: 'Mutation', preventAutomaticCancellation: { __typename?: 'CheckoutSessionType', success: boolean, error?: string | null, checkoutSessionUrl?: string | null } };

export type RetryUploadMutationVariables = Exact<{
  knowledgeDataId: Scalars['ID']['input'];
}>;


export type RetryUploadMutation = { __typename?: 'Mutation', retryUpload: { __typename?: 'ErrorType', message: string } | { __typename?: 'SuccessType', message: string } };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  agentId: Scalars['ID']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'ErrorType', message: string } | { __typename?: 'UploadedKnowledgeDataSuccessType', message: string, knowledgeData: { __typename?: 'BaseKnowledgeDataType', id: string, source: string, active: boolean, sourceType: string, text: string, createdAt: any } } };

export type UploadUrlMutationVariables = Exact<{
  url: Scalars['String']['input'];
  agentId: Scalars['ID']['input'];
}>;


export type UploadUrlMutation = { __typename?: 'Mutation', uploadUrl: { __typename?: 'ErrorType', message: string } | { __typename?: 'UploadedKnowledgeDataSuccessType', message: string, knowledgeData: { __typename?: 'BaseKnowledgeDataType', id: string, source: string, active: boolean, sourceType: string, text: string, createdAt: any } } };

export type GetAgentVoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentVoicesQuery = { __typename?: 'Query', getAgentVoices: { __typename?: 'AgentVoicesType', success: boolean, error?: string | null, voices?: Array<{ __typename?: 'AgentVoiceType', id: string, name: string, description?: string | null, previewUrl?: string | null, available: boolean }> | null } };

export type GetCurrentSubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentSubscriptionInfoQuery = { __typename?: 'Query', getCurrentSubscriptionInfo: { __typename?: 'SubscriptionInfoType', success: boolean, error?: string | null, subscription?: { __typename?: 'SubscriptionType', planName: string, features: Array<string>, priceAmount: number, nextBillingDate: any, status: string, cancelAtPeriodEnd: boolean, nextBillingAmount: number, trialEnd?: any | null } | null } };

export type GetCurrentUserMinutesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserMinutesQuery = { __typename?: 'Query', getCurrentUserMinutes: number };

export type GetKnowledgeDataQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type GetKnowledgeDataQuery = { __typename?: 'Query', getKnowledgeData: { __typename?: 'KnowledgeDataType', success: boolean, error?: string | null, id: string, knowledgeData?: Array<{ __typename?: 'BaseKnowledgeDataType', id: string, processingStatus: string, source: string, active: boolean, sourceType: string, text: string, createdAt: any }> | null } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe: { __typename?: 'ErrorType', message: string } | { __typename?: 'UserModelType', id: string, email: string, firstName?: string | null, lastName?: string | null, isActive: boolean, isStaff: boolean, website?: string | null, phoneNumber?: string | null, isVerified: boolean, timeZone?: string | null, language: number, isAgentCreated: boolean, isSubscribed: boolean, isAgentDelete: boolean, isFinishedStepper: boolean, key: string, isAllowToStepper: any, company?: { __typename?: 'CompanyType', id: string, name: string } | null } };

export type GetPhoneNumbersQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  cityCode?: InputMaybe<Scalars['Int']['input']>;
  numberType: Scalars['String']['input'];
}>;


export type GetPhoneNumbersQuery = { __typename?: 'Query', getPhoneNumbers: { __typename?: 'PhoneNumbersType', success: boolean, error?: string | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumberType', phoneNumber: string }> | null } };

export type GetTimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeZonesQuery = { __typename?: 'Query', getTimeZones: { __typename?: 'TimeZone', listTimeZones: Array<string> } };

export type GetUserAgentByIdQueryVariables = Exact<{
  agentId: Scalars['Int']['input'];
}>;


export type GetUserAgentByIdQuery = { __typename?: 'Query', getUserAgentById: { __typename: 'AgentCreateType', agent: { __typename?: 'AgentType', id: string, name?: string | null, title: string, phoneNumber?: string | null, priceId: string, userSubscriptionPremium?: boolean | null, userSubscriptionCancelDate?: string | null, hostedInvoiceUrl?: string | null, callTransferActive: boolean, googleCalendar: boolean, initialMessage: string, trainingGuide?: string | null, callService: string, timeZone: string, fillerAudio?: { __typename?: 'FillerAudioType', active: boolean } | null, callTransfer: Array<{ __typename?: 'CallTransferType', id: string, phoneNumber: string, instructionBeforTransfer?: string | null, beforTransferingMsg: string, callerIdStatus: number }>, terminateCallAction?: { __typename?: 'TerminateCallActionType', active: boolean, code: string } | null, textNotification?: { __typename?: 'TextNotificationType', active: boolean, phoneNumber?: string | null } | null, emailNotification?: { __typename?: 'EmailNotificationType', active: boolean, email1?: string | null, email2?: string | null, email3?: string | null } | null } } | { __typename: 'ErrorType', message: string } };

export type GetUserAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAgentsQuery = { __typename?: 'Query', getUserAgents: { __typename?: 'AgentsType', id: string, callService: string, agents: Array<{ __typename?: 'AgentType', id: string, name?: string | null, title: string, phoneNumber?: string | null, priceId: string, userSubscriptionPremium?: boolean | null, userSubscriptionCancelDate?: string | null, hostedInvoiceUrl?: string | null, callTransferActive: boolean, googleCalendar: boolean, initialMessage: string, trainingGuide?: string | null, callService: string, timeZone: string, businessAddress?: { __typename?: 'BusinessAddressType', bundleStatus?: string | null, failureReason?: string | null } | null, fillerAudio?: { __typename?: 'FillerAudioType', active: boolean } | null, callTransfer: Array<{ __typename?: 'CallTransferType', id: string, phoneNumber: string, instructionBeforTransfer?: string | null, beforTransferingMsg: string, callerIdStatus: number }>, terminateCallAction?: { __typename?: 'TerminateCallActionType', active: boolean, code: string } | null, textNotification?: { __typename?: 'TextNotificationType', active: boolean, phoneNumber?: string | null } | null, emailNotification?: { __typename?: 'EmailNotificationType', active: boolean, email1?: string | null, email2?: string | null, email3?: string | null } | null }> } };

export type CheckProcessingStatusSubscriptionVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type CheckProcessingStatusSubscription = { __typename?: 'Subscription', checkProcessingStatus: Array<any> };


export const BuyTelephoneNumberDocument = gql`
    mutation buyTelephoneNumber($agentId: ID!, $phoneNumber: String!) {
  buyTelephoneNumber(agentId: $agentId, phoneNumber: $phoneNumber) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type BuyTelephoneNumberMutationFn = Apollo.MutationFunction<BuyTelephoneNumberMutation, BuyTelephoneNumberMutationVariables>;

/**
 * __useBuyTelephoneNumberMutation__
 *
 * To run a mutation, you first call `useBuyTelephoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyTelephoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyTelephoneNumberMutation, { data, loading, error }] = useBuyTelephoneNumberMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useBuyTelephoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<BuyTelephoneNumberMutation, BuyTelephoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyTelephoneNumberMutation, BuyTelephoneNumberMutationVariables>(BuyTelephoneNumberDocument, options);
      }
export type BuyTelephoneNumberMutationHookResult = ReturnType<typeof useBuyTelephoneNumberMutation>;
export type BuyTelephoneNumberMutationResult = Apollo.MutationResult<BuyTelephoneNumberMutation>;
export type BuyTelephoneNumberMutationOptions = Apollo.BaseMutationOptions<BuyTelephoneNumberMutation, BuyTelephoneNumberMutationVariables>;
export const ChangeAgentVoiceDocument = gql`
    mutation changeAgentVoice($voiceId: Int!, $agentId: ID!) {
  changeAgentVoice(voiceId: $voiceId, agentId: $agentId) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type ChangeAgentVoiceMutationFn = Apollo.MutationFunction<ChangeAgentVoiceMutation, ChangeAgentVoiceMutationVariables>;

/**
 * __useChangeAgentVoiceMutation__
 *
 * To run a mutation, you first call `useChangeAgentVoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAgentVoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAgentVoiceMutation, { data, loading, error }] = useChangeAgentVoiceMutation({
 *   variables: {
 *      voiceId: // value for 'voiceId'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useChangeAgentVoiceMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAgentVoiceMutation, ChangeAgentVoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAgentVoiceMutation, ChangeAgentVoiceMutationVariables>(ChangeAgentVoiceDocument, options);
      }
export type ChangeAgentVoiceMutationHookResult = ReturnType<typeof useChangeAgentVoiceMutation>;
export type ChangeAgentVoiceMutationResult = Apollo.MutationResult<ChangeAgentVoiceMutation>;
export type ChangeAgentVoiceMutationOptions = Apollo.BaseMutationOptions<ChangeAgentVoiceMutation, ChangeAgentVoiceMutationVariables>;
export const ChangeCallServiceByAgentIdDocument = gql`
    mutation changeCallServiceByAgentId($serviceType: String!, $agentId: ID!) {
  changeCallServiceByAgentId(serviceType: $serviceType, agentId: $agentId) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type ChangeCallServiceByAgentIdMutationFn = Apollo.MutationFunction<ChangeCallServiceByAgentIdMutation, ChangeCallServiceByAgentIdMutationVariables>;

/**
 * __useChangeCallServiceByAgentIdMutation__
 *
 * To run a mutation, you first call `useChangeCallServiceByAgentIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCallServiceByAgentIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCallServiceByAgentIdMutation, { data, loading, error }] = useChangeCallServiceByAgentIdMutation({
 *   variables: {
 *      serviceType: // value for 'serviceType'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useChangeCallServiceByAgentIdMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCallServiceByAgentIdMutation, ChangeCallServiceByAgentIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCallServiceByAgentIdMutation, ChangeCallServiceByAgentIdMutationVariables>(ChangeCallServiceByAgentIdDocument, options);
      }
export type ChangeCallServiceByAgentIdMutationHookResult = ReturnType<typeof useChangeCallServiceByAgentIdMutation>;
export type ChangeCallServiceByAgentIdMutationResult = Apollo.MutationResult<ChangeCallServiceByAgentIdMutation>;
export type ChangeCallServiceByAgentIdMutationOptions = Apollo.BaseMutationOptions<ChangeCallServiceByAgentIdMutation, ChangeCallServiceByAgentIdMutationVariables>;
export const ChangeInitialMessageDocument = gql`
    mutation changeInitialMessage($initialMessage: String!, $agentId: ID!) {
  changeInitialMessage(initialMessage: $initialMessage, agentId: $agentId) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type ChangeInitialMessageMutationFn = Apollo.MutationFunction<ChangeInitialMessageMutation, ChangeInitialMessageMutationVariables>;

/**
 * __useChangeInitialMessageMutation__
 *
 * To run a mutation, you first call `useChangeInitialMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeInitialMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeInitialMessageMutation, { data, loading, error }] = useChangeInitialMessageMutation({
 *   variables: {
 *      initialMessage: // value for 'initialMessage'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useChangeInitialMessageMutation(baseOptions?: Apollo.MutationHookOptions<ChangeInitialMessageMutation, ChangeInitialMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeInitialMessageMutation, ChangeInitialMessageMutationVariables>(ChangeInitialMessageDocument, options);
      }
export type ChangeInitialMessageMutationHookResult = ReturnType<typeof useChangeInitialMessageMutation>;
export type ChangeInitialMessageMutationResult = Apollo.MutationResult<ChangeInitialMessageMutation>;
export type ChangeInitialMessageMutationOptions = Apollo.BaseMutationOptions<ChangeInitialMessageMutation, ChangeInitialMessageMutationVariables>;
export const ChangeKnowledgeDataStatusDocument = gql`
    mutation changeKnowledgeDataStatus($knowledgeDataId: ID!, $status: Boolean!) {
  changeKnowledgeDataStatus(knowledgeDataId: $knowledgeDataId, status: $status) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type ChangeKnowledgeDataStatusMutationFn = Apollo.MutationFunction<ChangeKnowledgeDataStatusMutation, ChangeKnowledgeDataStatusMutationVariables>;

/**
 * __useChangeKnowledgeDataStatusMutation__
 *
 * To run a mutation, you first call `useChangeKnowledgeDataStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeKnowledgeDataStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeKnowledgeDataStatusMutation, { data, loading, error }] = useChangeKnowledgeDataStatusMutation({
 *   variables: {
 *      knowledgeDataId: // value for 'knowledgeDataId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeKnowledgeDataStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeKnowledgeDataStatusMutation, ChangeKnowledgeDataStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeKnowledgeDataStatusMutation, ChangeKnowledgeDataStatusMutationVariables>(ChangeKnowledgeDataStatusDocument, options);
      }
export type ChangeKnowledgeDataStatusMutationHookResult = ReturnType<typeof useChangeKnowledgeDataStatusMutation>;
export type ChangeKnowledgeDataStatusMutationResult = Apollo.MutationResult<ChangeKnowledgeDataStatusMutation>;
export type ChangeKnowledgeDataStatusMutationOptions = Apollo.BaseMutationOptions<ChangeKnowledgeDataStatusMutation, ChangeKnowledgeDataStatusMutationVariables>;
export const ChangeTrainingGuideDocument = gql`
    mutation changeTrainingGuide($newGuide: String!, $agentId: ID!) {
  changeTrainingGuide(newGuide: $newGuide, agentId: $agentId) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type ChangeTrainingGuideMutationFn = Apollo.MutationFunction<ChangeTrainingGuideMutation, ChangeTrainingGuideMutationVariables>;

/**
 * __useChangeTrainingGuideMutation__
 *
 * To run a mutation, you first call `useChangeTrainingGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTrainingGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTrainingGuideMutation, { data, loading, error }] = useChangeTrainingGuideMutation({
 *   variables: {
 *      newGuide: // value for 'newGuide'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useChangeTrainingGuideMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTrainingGuideMutation, ChangeTrainingGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTrainingGuideMutation, ChangeTrainingGuideMutationVariables>(ChangeTrainingGuideDocument, options);
      }
export type ChangeTrainingGuideMutationHookResult = ReturnType<typeof useChangeTrainingGuideMutation>;
export type ChangeTrainingGuideMutationResult = Apollo.MutationResult<ChangeTrainingGuideMutation>;
export type ChangeTrainingGuideMutationOptions = Apollo.BaseMutationOptions<ChangeTrainingGuideMutation, ChangeTrainingGuideMutationVariables>;
export const CreatePortalSessionDocument = gql`
    mutation createPortalSession($manageType: String! = "") {
  createPortalSession(manageType: $manageType) {
    success
    error
    portalSessionUrl
  }
}
    `;
export type CreatePortalSessionMutationFn = Apollo.MutationFunction<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>;

/**
 * __useCreatePortalSessionMutation__
 *
 * To run a mutation, you first call `useCreatePortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortalSessionMutation, { data, loading, error }] = useCreatePortalSessionMutation({
 *   variables: {
 *      manageType: // value for 'manageType'
 *   },
 * });
 */
export function useCreatePortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>(CreatePortalSessionDocument, options);
      }
export type CreatePortalSessionMutationHookResult = ReturnType<typeof useCreatePortalSessionMutation>;
export type CreatePortalSessionMutationResult = Apollo.MutationResult<CreatePortalSessionMutation>;
export type CreatePortalSessionMutationOptions = Apollo.BaseMutationOptions<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>;
export const DeleteKnowledgeDataDocument = gql`
    mutation deleteKnowledgeData($knowledgeDataId: ID!) {
  deleteKnowledgeData(knowledgeDataId: $knowledgeDataId) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type DeleteKnowledgeDataMutationFn = Apollo.MutationFunction<DeleteKnowledgeDataMutation, DeleteKnowledgeDataMutationVariables>;

/**
 * __useDeleteKnowledgeDataMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeDataMutation, { data, loading, error }] = useDeleteKnowledgeDataMutation({
 *   variables: {
 *      knowledgeDataId: // value for 'knowledgeDataId'
 *   },
 * });
 */
export function useDeleteKnowledgeDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeDataMutation, DeleteKnowledgeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeDataMutation, DeleteKnowledgeDataMutationVariables>(DeleteKnowledgeDataDocument, options);
      }
export type DeleteKnowledgeDataMutationHookResult = ReturnType<typeof useDeleteKnowledgeDataMutation>;
export type DeleteKnowledgeDataMutationResult = Apollo.MutationResult<DeleteKnowledgeDataMutation>;
export type DeleteKnowledgeDataMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeDataMutation, DeleteKnowledgeDataMutationVariables>;
export const PreventAutomaticCancellationDocument = gql`
    mutation preventAutomaticCancellation($email: String!) {
  preventAutomaticCancellation(email: $email) {
    ... on CheckoutSessionType {
      success
      error
      checkoutSessionUrl
    }
  }
}
    `;
export type PreventAutomaticCancellationMutationFn = Apollo.MutationFunction<PreventAutomaticCancellationMutation, PreventAutomaticCancellationMutationVariables>;

/**
 * __usePreventAutomaticCancellationMutation__
 *
 * To run a mutation, you first call `usePreventAutomaticCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreventAutomaticCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preventAutomaticCancellationMutation, { data, loading, error }] = usePreventAutomaticCancellationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePreventAutomaticCancellationMutation(baseOptions?: Apollo.MutationHookOptions<PreventAutomaticCancellationMutation, PreventAutomaticCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreventAutomaticCancellationMutation, PreventAutomaticCancellationMutationVariables>(PreventAutomaticCancellationDocument, options);
      }
export type PreventAutomaticCancellationMutationHookResult = ReturnType<typeof usePreventAutomaticCancellationMutation>;
export type PreventAutomaticCancellationMutationResult = Apollo.MutationResult<PreventAutomaticCancellationMutation>;
export type PreventAutomaticCancellationMutationOptions = Apollo.BaseMutationOptions<PreventAutomaticCancellationMutation, PreventAutomaticCancellationMutationVariables>;
export const RetryUploadDocument = gql`
    mutation retryUpload($knowledgeDataId: ID!) {
  retryUpload(knowledgeDataId: $knowledgeDataId) {
    ... on SuccessType {
      message
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type RetryUploadMutationFn = Apollo.MutationFunction<RetryUploadMutation, RetryUploadMutationVariables>;

/**
 * __useRetryUploadMutation__
 *
 * To run a mutation, you first call `useRetryUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryUploadMutation, { data, loading, error }] = useRetryUploadMutation({
 *   variables: {
 *      knowledgeDataId: // value for 'knowledgeDataId'
 *   },
 * });
 */
export function useRetryUploadMutation(baseOptions?: Apollo.MutationHookOptions<RetryUploadMutation, RetryUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryUploadMutation, RetryUploadMutationVariables>(RetryUploadDocument, options);
      }
export type RetryUploadMutationHookResult = ReturnType<typeof useRetryUploadMutation>;
export type RetryUploadMutationResult = Apollo.MutationResult<RetryUploadMutation>;
export type RetryUploadMutationOptions = Apollo.BaseMutationOptions<RetryUploadMutation, RetryUploadMutationVariables>;
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!, $agentId: ID!) {
  uploadFile(file: $file, agentId: $agentId) {
    ... on UploadedKnowledgeDataSuccessType {
      message
      knowledgeData {
        id
        source
        active
        sourceType
        text
        createdAt
      }
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const UploadUrlDocument = gql`
    mutation uploadUrl($url: String!, $agentId: ID!) {
  uploadUrl(url: $url, agentId: $agentId) {
    ... on UploadedKnowledgeDataSuccessType {
      message
      knowledgeData {
        id
        source
        active
        sourceType
        text
        createdAt
      }
    }
    ... on ErrorType {
      message
    }
  }
}
    `;
export type UploadUrlMutationFn = Apollo.MutationFunction<UploadUrlMutation, UploadUrlMutationVariables>;

/**
 * __useUploadUrlMutation__
 *
 * To run a mutation, you first call `useUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUrlMutation, { data, loading, error }] = useUploadUrlMutation({
 *   variables: {
 *      url: // value for 'url'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<UploadUrlMutation, UploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUrlMutation, UploadUrlMutationVariables>(UploadUrlDocument, options);
      }
export type UploadUrlMutationHookResult = ReturnType<typeof useUploadUrlMutation>;
export type UploadUrlMutationResult = Apollo.MutationResult<UploadUrlMutation>;
export type UploadUrlMutationOptions = Apollo.BaseMutationOptions<UploadUrlMutation, UploadUrlMutationVariables>;
export const GetAgentVoicesDocument = gql`
    query getAgentVoices {
  getAgentVoices {
    success
    error
    voices {
      id
      name
      description
      previewUrl
      available
    }
  }
}
    `;

/**
 * __useGetAgentVoicesQuery__
 *
 * To run a query within a React component, call `useGetAgentVoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentVoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentVoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentVoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentVoicesQuery, GetAgentVoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentVoicesQuery, GetAgentVoicesQueryVariables>(GetAgentVoicesDocument, options);
      }
export function useGetAgentVoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentVoicesQuery, GetAgentVoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentVoicesQuery, GetAgentVoicesQueryVariables>(GetAgentVoicesDocument, options);
        }
export function useGetAgentVoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentVoicesQuery, GetAgentVoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentVoicesQuery, GetAgentVoicesQueryVariables>(GetAgentVoicesDocument, options);
        }
export type GetAgentVoicesQueryHookResult = ReturnType<typeof useGetAgentVoicesQuery>;
export type GetAgentVoicesLazyQueryHookResult = ReturnType<typeof useGetAgentVoicesLazyQuery>;
export type GetAgentVoicesSuspenseQueryHookResult = ReturnType<typeof useGetAgentVoicesSuspenseQuery>;
export type GetAgentVoicesQueryResult = Apollo.QueryResult<GetAgentVoicesQuery, GetAgentVoicesQueryVariables>;
export const GetCurrentSubscriptionInfoDocument = gql`
    query getCurrentSubscriptionInfo {
  getCurrentSubscriptionInfo {
    success
    error
    subscription {
      planName
      features
      priceAmount
      nextBillingDate
      status
      cancelAtPeriodEnd
      nextBillingAmount
      trialEnd
    }
  }
}
    `;

/**
 * __useGetCurrentSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentSubscriptionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentSubscriptionInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentSubscriptionInfoQuery, GetCurrentSubscriptionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentSubscriptionInfoQuery, GetCurrentSubscriptionInfoQueryVariables>(GetCurrentSubscriptionInfoDocument, options);
      }
export function useGetCurrentSubscriptionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentSubscriptionInfoQuery, GetCurrentSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentSubscriptionInfoQuery, GetCurrentSubscriptionInfoQueryVariables>(GetCurrentSubscriptionInfoDocument, options);
        }
export function useGetCurrentSubscriptionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentSubscriptionInfoQuery, GetCurrentSubscriptionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentSubscriptionInfoQuery, GetCurrentSubscriptionInfoQueryVariables>(GetCurrentSubscriptionInfoDocument, options);
        }
export type GetCurrentSubscriptionInfoQueryHookResult = ReturnType<typeof useGetCurrentSubscriptionInfoQuery>;
export type GetCurrentSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useGetCurrentSubscriptionInfoLazyQuery>;
export type GetCurrentSubscriptionInfoSuspenseQueryHookResult = ReturnType<typeof useGetCurrentSubscriptionInfoSuspenseQuery>;
export type GetCurrentSubscriptionInfoQueryResult = Apollo.QueryResult<GetCurrentSubscriptionInfoQuery, GetCurrentSubscriptionInfoQueryVariables>;
export const GetCurrentUserMinutesDocument = gql`
    query getCurrentUserMinutes {
  getCurrentUserMinutes
}
    `;

/**
 * __useGetCurrentUserMinutesQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserMinutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserMinutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserMinutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserMinutesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserMinutesQuery, GetCurrentUserMinutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserMinutesQuery, GetCurrentUserMinutesQueryVariables>(GetCurrentUserMinutesDocument, options);
      }
export function useGetCurrentUserMinutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserMinutesQuery, GetCurrentUserMinutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserMinutesQuery, GetCurrentUserMinutesQueryVariables>(GetCurrentUserMinutesDocument, options);
        }
export function useGetCurrentUserMinutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserMinutesQuery, GetCurrentUserMinutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserMinutesQuery, GetCurrentUserMinutesQueryVariables>(GetCurrentUserMinutesDocument, options);
        }
export type GetCurrentUserMinutesQueryHookResult = ReturnType<typeof useGetCurrentUserMinutesQuery>;
export type GetCurrentUserMinutesLazyQueryHookResult = ReturnType<typeof useGetCurrentUserMinutesLazyQuery>;
export type GetCurrentUserMinutesSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserMinutesSuspenseQuery>;
export type GetCurrentUserMinutesQueryResult = Apollo.QueryResult<GetCurrentUserMinutesQuery, GetCurrentUserMinutesQueryVariables>;
export const GetKnowledgeDataDocument = gql`
    query getKnowledgeData($agentId: ID!) {
  getKnowledgeData(agentId: $agentId) {
    success
    error
    id
    knowledgeData {
      id
      processingStatus
      source
      active
      sourceType
      text
      createdAt
    }
  }
}
    `;

/**
 * __useGetKnowledgeDataQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeDataQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetKnowledgeDataQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeDataQuery, GetKnowledgeDataQueryVariables> & ({ variables: GetKnowledgeDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeDataQuery, GetKnowledgeDataQueryVariables>(GetKnowledgeDataDocument, options);
      }
export function useGetKnowledgeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeDataQuery, GetKnowledgeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeDataQuery, GetKnowledgeDataQueryVariables>(GetKnowledgeDataDocument, options);
        }
export function useGetKnowledgeDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeDataQuery, GetKnowledgeDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeDataQuery, GetKnowledgeDataQueryVariables>(GetKnowledgeDataDocument, options);
        }
export type GetKnowledgeDataQueryHookResult = ReturnType<typeof useGetKnowledgeDataQuery>;
export type GetKnowledgeDataLazyQueryHookResult = ReturnType<typeof useGetKnowledgeDataLazyQuery>;
export type GetKnowledgeDataSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeDataSuspenseQuery>;
export type GetKnowledgeDataQueryResult = Apollo.QueryResult<GetKnowledgeDataQuery, GetKnowledgeDataQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  getMe {
    ... on UserModelType {
      id
      email
      firstName
      lastName
      isActive
      isStaff
      website
      phoneNumber
      isVerified
      timeZone
      language
      isAgentCreated
      isSubscribed
      isAgentDelete
      isFinishedStepper
      key
      isAllowToStepper
      company {
        id
        name
      }
    }
    ... on ErrorType {
      message
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetPhoneNumbersDocument = gql`
    query getPhoneNumbers($countryCode: String!, $limit: Int!, $cityCode: Int = null, $numberType: String!) {
  getPhoneNumbers(
    countryCode: $countryCode
    limit: $limit
    cityCode: $cityCode
    numberType: $numberType
  ) {
    ... on PhoneNumbersType {
      success
      error
      phoneNumbers {
        phoneNumber
      }
    }
  }
}
    `;

/**
 * __useGetPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneNumbersQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      limit: // value for 'limit'
 *      cityCode: // value for 'cityCode'
 *      numberType: // value for 'numberType'
 *   },
 * });
 */
export function useGetPhoneNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables> & ({ variables: GetPhoneNumbersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>(GetPhoneNumbersDocument, options);
      }
export function useGetPhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>(GetPhoneNumbersDocument, options);
        }
export function useGetPhoneNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>(GetPhoneNumbersDocument, options);
        }
export type GetPhoneNumbersQueryHookResult = ReturnType<typeof useGetPhoneNumbersQuery>;
export type GetPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetPhoneNumbersLazyQuery>;
export type GetPhoneNumbersSuspenseQueryHookResult = ReturnType<typeof useGetPhoneNumbersSuspenseQuery>;
export type GetPhoneNumbersQueryResult = Apollo.QueryResult<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>;
export const GetTimeZonesDocument = gql`
    query getTimeZones {
  getTimeZones {
    listTimeZones
  }
}
    `;

/**
 * __useGetTimeZonesQuery__
 *
 * To run a query within a React component, call `useGetTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimeZonesQuery(baseOptions?: Apollo.QueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
      }
export function useGetTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
        }
export function useGetTimeZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
        }
export type GetTimeZonesQueryHookResult = ReturnType<typeof useGetTimeZonesQuery>;
export type GetTimeZonesLazyQueryHookResult = ReturnType<typeof useGetTimeZonesLazyQuery>;
export type GetTimeZonesSuspenseQueryHookResult = ReturnType<typeof useGetTimeZonesSuspenseQuery>;
export type GetTimeZonesQueryResult = Apollo.QueryResult<GetTimeZonesQuery, GetTimeZonesQueryVariables>;
export const GetUserAgentByIdDocument = gql`
    query getUserAgentById($agentId: Int!) {
  getUserAgentById(agentId: $agentId) {
    ... on AgentCreateType {
      __typename
      agent {
        id
        name
        title
        phoneNumber
        priceId
        userSubscriptionPremium
        userSubscriptionCancelDate
        hostedInvoiceUrl
        callTransferActive
        googleCalendar
        fillerAudio {
          active
        }
        callTransfer {
          id
          phoneNumber
          instructionBeforTransfer
          beforTransferingMsg
          callerIdStatus
        }
        terminateCallAction {
          active
          code
        }
        textNotification {
          active
          phoneNumber
        }
        emailNotification {
          active
          email1
          email2
          email3
        }
        initialMessage
        trainingGuide
        callService
        timeZone
      }
    }
    ... on ErrorType {
      __typename
      message
    }
  }
}
    `;

/**
 * __useGetUserAgentByIdQuery__
 *
 * To run a query within a React component, call `useGetUserAgentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAgentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAgentByIdQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetUserAgentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserAgentByIdQuery, GetUserAgentByIdQueryVariables> & ({ variables: GetUserAgentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAgentByIdQuery, GetUserAgentByIdQueryVariables>(GetUserAgentByIdDocument, options);
      }
export function useGetUserAgentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAgentByIdQuery, GetUserAgentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAgentByIdQuery, GetUserAgentByIdQueryVariables>(GetUserAgentByIdDocument, options);
        }
export function useGetUserAgentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAgentByIdQuery, GetUserAgentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAgentByIdQuery, GetUserAgentByIdQueryVariables>(GetUserAgentByIdDocument, options);
        }
export type GetUserAgentByIdQueryHookResult = ReturnType<typeof useGetUserAgentByIdQuery>;
export type GetUserAgentByIdLazyQueryHookResult = ReturnType<typeof useGetUserAgentByIdLazyQuery>;
export type GetUserAgentByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserAgentByIdSuspenseQuery>;
export type GetUserAgentByIdQueryResult = Apollo.QueryResult<GetUserAgentByIdQuery, GetUserAgentByIdQueryVariables>;
export const GetUserAgentsDocument = gql`
    query getUserAgents {
  getUserAgents {
    id
    callService
    agents {
      id
      name
      title
      phoneNumber
      priceId
      userSubscriptionPremium
      userSubscriptionCancelDate
      hostedInvoiceUrl
      callTransferActive
      googleCalendar
      businessAddress {
        bundleStatus
        failureReason
      }
      fillerAudio {
        active
      }
      callTransfer {
        id
        phoneNumber
        instructionBeforTransfer
        beforTransferingMsg
        callerIdStatus
      }
      terminateCallAction {
        active
        code
      }
      textNotification {
        active
        phoneNumber
      }
      emailNotification {
        active
        email1
        email2
        email3
      }
      initialMessage
      trainingGuide
      callService
      timeZone
    }
  }
}
    `;

/**
 * __useGetUserAgentsQuery__
 *
 * To run a query within a React component, call `useGetUserAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAgentsQuery, GetUserAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAgentsQuery, GetUserAgentsQueryVariables>(GetUserAgentsDocument, options);
      }
export function useGetUserAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAgentsQuery, GetUserAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAgentsQuery, GetUserAgentsQueryVariables>(GetUserAgentsDocument, options);
        }
export function useGetUserAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAgentsQuery, GetUserAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAgentsQuery, GetUserAgentsQueryVariables>(GetUserAgentsDocument, options);
        }
export type GetUserAgentsQueryHookResult = ReturnType<typeof useGetUserAgentsQuery>;
export type GetUserAgentsLazyQueryHookResult = ReturnType<typeof useGetUserAgentsLazyQuery>;
export type GetUserAgentsSuspenseQueryHookResult = ReturnType<typeof useGetUserAgentsSuspenseQuery>;
export type GetUserAgentsQueryResult = Apollo.QueryResult<GetUserAgentsQuery, GetUserAgentsQueryVariables>;
export const CheckProcessingStatusDocument = gql`
    subscription checkProcessingStatus($agentId: ID!) {
  checkProcessingStatus(agentId: $agentId)
}
    `;

/**
 * __useCheckProcessingStatusSubscription__
 *
 * To run a query within a React component, call `useCheckProcessingStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCheckProcessingStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProcessingStatusSubscription({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useCheckProcessingStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<CheckProcessingStatusSubscription, CheckProcessingStatusSubscriptionVariables> & ({ variables: CheckProcessingStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CheckProcessingStatusSubscription, CheckProcessingStatusSubscriptionVariables>(CheckProcessingStatusDocument, options);
      }
export type CheckProcessingStatusSubscriptionHookResult = ReturnType<typeof useCheckProcessingStatusSubscription>;
export type CheckProcessingStatusSubscriptionResult = Apollo.SubscriptionResult<CheckProcessingStatusSubscription>;

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export function BlockedNumberInputSchema(): z.ZodObject<Properties<BlockedNumberInput>> {
  return z.object({
    id: z.string().nullish(),
    phoneNumber: z.string().nullish()
  })
}

export function CallTransferInputSchema(): z.ZodObject<Properties<CallTransferInput>> {
  return z.object({
    beforTransferingMsg: z.string().nullish(),
    callerIdStatus: z.number().nullish(),
    id: z.string().nullish(),
    instructionBeforTransfer: z.string().nullish(),
    phoneNumber: z.string().nullish()
  })
}

export function QuestionAnswerTypeSchema(): z.ZodObject<Properties<QuestionAnswerType>> {
  return z.object({
    answer: z.string(),
    questionId: z.number()
  })
}
